/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-21 19:12:51
 * @LastEditors: liuziwei
 * @Description: 首页领券 banner - item 组件
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="coupon-container">
    <text wx:if="{{couponInfo.name}}">{{ couponInfo.name }}</text>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      couponData: {
        type: Object,
        value: () => {}
      }
    },
    computed: {
      // 优惠券信息
      couponInfo() {
        return this.couponData?.coupon_info ?? {}
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .coupon-container
    border-radius 2px
    border 0.5px solid #FF4343
    padding 4px 5px
    margin-right 8px
    font-family PingFang SC
    font-size 10px
    font-weight 500
    line-height 10px
    color #FF4343
    flex-shrink 0
    position relative
    // 替换成 drop-shadow
    -webkit-mask radial-gradient(circle at 3px, transparent 3px, #000 0) -3px
    mask radial-gradient(circle at 3px , transparent 3px, #000 0) -3px
    &:last-child
      margin-right 0
    &::before, &::after
      content ''
      position absolute
      top 5.2px
      width 8.2px
      height 6.5px
      border-radius 50%
      border 0.5px solid #FF4343
    &::before
      left -5.2px
    &::after
      right -5.2px
</style>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>
